import { Indicator } from '@mantine/core'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { Tooltip } from '@percent/lemonade'
import { DatePicker } from '@percent/workplace-giving/common/components/DatePicker/DatePicker'
import { useColorTheme } from '@percent/workplace-giving/common/hooks/useColorTheme/useColorTheme'
import classes from './LoggedDaysCalendar.module.scss'
import type { LoggedDaysCalendarProps } from './LoggedDaysCalendar.types'

const LOGGED_DOT_SIZE = 6
const LOGGED_DOT_OFFSET = -4

/** Days already logged get a dot and are unselectable, so the enabled days are the ones left to log. */
export function LoggedDaysCalendar({ loggedDates = [], ...datePickerProps }: LoggedDaysCalendarProps) {
  const { t } = useTranslation()
  const { theme } = useColorTheme()

  const isLoggedDay = (date: Date) => loggedDates.some(loggedDate => dayjs(loggedDate).isSame(date, 'day'))

  return (
    <DatePicker
      {...datePickerProps}
      excludeDate={isLoggedDay}
      getDayProps={date => (isLoggedDay(date) ? { className: classes.LoggedDay } : {})}
      renderDay={date => {
        const day = (
          <Indicator
            size={LOGGED_DOT_SIZE}
            offset={LOGGED_DOT_OFFSET}
            color={theme.success400}
            position="bottom-center"
            disabled={!isLoggedDay(date)}
          >
            <span>{date.getDate()}</span>
          </Indicator>
        )

        return isLoggedDay(date) ? (
          <Tooltip content={t('workplace_giving.givingActions.completionModal.loggedDayTooltip')}>{day}</Tooltip>
        ) : (
          day
        )
      }}
    />
  )
}
